module.exports = __webpack_public_path__ + "img/logoIcon.07c542c8.png";